// eslint-disable-next-line no-useless-escape
export default new RegExp('^[a-zA-Z0-9._]+$')
